export default __webpack_public_path__ + "static/media/rabbit14.46e16e85.gif";